
// import React, { useState } from "react";
// import { useLocation, useNavigate, useParams } from "react-router-dom";
// import axios from "axios";
// import NativeCameraCapture from '../media/NativeCameraCapture';
// import ImageUploadModal from '../media/ImageUploadModal';
// import AppFooter from '../AppFooter';
// import { FaCamera, FaUpload, FaSave, FaArrowLeft, FaTrash } from 'react-icons/fa';

// const MemberDetail = () => {
//   const { state } = useLocation();
//   const { tenant } = useParams();
//   const navigate = useNavigate();
//   const baseUrl = process.env.REACT_APP_BASE_URL || 'http://localhost:5000';
  
//   // Initialize state from passed member data
//   const [member, setMember] = useState(state?.member || {});
//   const [updateStatus, setUpdateStatus] = useState('');
//   const [uploading, setUploading] = useState(false);
  
//   // Image/camera state
//   const [showNativeCamera, setShowNativeCamera] = useState(false);
//   const [isImageModalOpen, setIsImageModalOpen] = useState(false);
//   const [imagePath, setImagePath] = useState(member?.image || null);
//   const [newImageUrl, setNewImageUrl] = useState(null);
//   const [selectedFile, setSelectedFile] = useState(null);

//   /**
//    * Handle native camera capture for updating member photo
//    * @param {File[]} capturedFiles - Files captured from native camera
//    */
//   const handleNativeCameraCapture = async (capturedFiles) => {
//     console.log('📸 Captured files for member update:', capturedFiles);
    
//     setShowNativeCamera(false);
    
//     if (!capturedFiles || capturedFiles.length === 0) {
//       return;
//     }

//     try {
//       setUploading(true);
      
//       const fileToUpload = capturedFiles[0];
//       const formData = new FormData();
//       formData.append('file', fileToUpload, fileToUpload.name);

//       console.log('📤 Uploading member photo:', fileToUpload.name);

//       // Upload using member upload endpoint
//       const uploadResponse = await axios.post(
//         `${baseUrl}/api/${tenant}/uploadmember`,
//         formData,
//         {
//           headers: { 'Content-Type': 'multipart/form-data' },
//           withCredentials: true
//         }
//       );

//       console.log('✅ Upload response:', uploadResponse.data);

//       if (uploadResponse.data?.success) {
//         const uploadedUrl = 
//           uploadResponse.data.url || 
//           (uploadResponse.data.filePath ? `${baseUrl}${uploadResponse.data.filePath}` : null);
        
//         if (uploadedUrl) {
//           setNewImageUrl(uploadedUrl);
//           setImagePath(uploadedUrl);
//           setSelectedFile(null);
          
//           // Update member state with new image
//           setMember(prev => ({ ...prev, image: uploadedUrl }));
          
//           console.log('✅ Photo updated successfully:', uploadedUrl);
//           setUpdateStatus('Photo uploaded! Click Save to apply changes.');
//         }
//       } else {
//         throw new Error(uploadResponse.data?.message || 'Upload failed');
//       }
//     } catch (error) {
//       console.error('❌ Upload failed:', error);
//       const errorMessage = 
//         error?.response?.data?.message || 
//         error?.message || 
//         'Failed to upload photo';
//       alert(errorMessage);
//       setUpdateStatus(errorMessage);
//     } finally {
//       setUploading(false);
//     }
//   };

//   /**
//    * Handle file upload from ImageUploadModal
//    * @param {File[]} files - Files selected from modal
//    */
//   const handleUploadComplete = async (files) => {
//     setIsImageModalOpen(false);
    
//     if (!files || files.length === 0) {
//       return;
//     }

//     try {
//       setUploading(true);
      
//       const fileToUpload = files[0];
//       const formData = new FormData();
//       formData.append('file', fileToUpload, fileToUpload.name);

//       const uploadResponse = await axios.post(
//         `${baseUrl}/api/${tenant}/uploadmember`,
//         formData,
//         {
//           headers: { 'Content-Type': 'multipart/form-data' },
//           withCredentials: true
//         }
//       );

//       if (uploadResponse.data?.success) {
//         const uploadedUrl = 
//           uploadResponse.data.url || 
//           (uploadResponse.data.filePath ? `${baseUrl}${uploadResponse.data.filePath}` : null);
        
//         if (uploadedUrl) {
//           setNewImageUrl(uploadedUrl);
//           setImagePath(uploadedUrl);
//           setMember(prev => ({ ...prev, image: uploadedUrl }));
//           setUpdateStatus('Photo uploaded! Click Save to apply changes.');
//         }
//       }
//     } catch (error) {
//       console.error('Upload failed:', error);
//       alert('Failed to upload photo');
//     } finally {
//       setUploading(false);
//     }
//   };

//   /**
//    * Remove member photo
//    */
//   const handleRemovePhoto = () => {
//     if (window.confirm('Remove member photo?')) {
//       setImagePath(null);
//       setNewImageUrl(null);
//       setSelectedFile(null);
//       setMember(prev => ({ ...prev, image: null }));
//       setUpdateStatus('Photo removed! Click Save to apply changes.');
//     }
//   };

//   /**
//    * Handle input changes for member fields
//    */
//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setMember((prev) => ({ ...prev, [name]: value }));
//     setUpdateStatus(''); // Clear status when user makes changes
//   };

//   /**
//    * Update member information
//    */
//   const updateMember = async (e) => {
//     if (e) e.preventDefault();
    
//     setUpdateStatus('');

//     try {
//       const response = await axios.post(
//         `${baseUrl}/api/${tenant}/updatemember`,
//         {
//           email: member.email,
//           firstname: member.firstname,
//           lastname: member.lastname,
//           address1: member.address1,
//           address2: member.address2,
//           city: member.city,
//           state: member.state,
//           zip: member.zip,
//           phone: member.phone,
//           image: member.image || null,
//         },
//         { withCredentials: true }
//       );

//       if (response.data?.success) {
//         setUpdateStatus('Member updated successfully!');
        
//         // Navigate back after short delay
//         setTimeout(() => {
//           navigate(`/${tenant}/members`);
//         }, 1500);
//       } else {
//         setUpdateStatus(response.data?.message || 'Update failed');
//       }
//     } catch (error) {
//       console.error('Error updating member:', error);
//       setUpdateStatus('Error updating member. Please try again.');
//     }
//   };

//   const handleCancel = () => {
//     navigate(`/${tenant}/members`);
//   };

//   const handleSave = () => {
//     updateMember();
//   };

//   return (
//     <div className="container">
//       <h2 className="hdr hdr--primary hdr--lg">Member Details</h2>
      
//       {/* Upload status indicator */}
//       {uploading && (
//         <div className="alert alert-info" style={{ marginBottom: '1rem' }}>
//           📤 Uploading photo...
//         </div>
//       )}

//       {/* Member Photo Preview */}
//       {imagePath && (
//         <div className="form-group">
//           <label>Member Photo:</label>
//           <div style={{ 
//             display: 'flex', 
//             alignItems: 'center', 
//             gap: 10,
//             marginTop: 10
//           }}>
//             <img
//               src={imagePath}
//               alt="Member"
//               style={{
//                 width: 150,
//                 height: 150,
//                 objectFit: 'cover',
//                 borderRadius: 8,
//                 border: '2px solid #ddd'
//               }}
//               onError={(e) => {
//                 e.currentTarget.src = '/images/user-icon.png';
//               }}
//             />
//             <button
//               type="button"
//               className="btn btn-sm btn-danger"
//               onClick={handleRemovePhoto}
//               disabled={uploading}
//               style={{ height: 'fit-content' }}
//             >
//               <FaTrash /> Remove Photo
//             </button>
//           </div>
//         </div>
//       )}

//       <form onSubmit={updateMember}>
//         <div className="form-group">
//           <label htmlFor="firstname">First Name</label>
//           <input
//             type="text"
//             className="form-control"
//             id="firstname"
//             name="firstname"
//             value={member.firstname || ""}
//             onChange={handleInputChange}
//             required
//           />
//         </div>
        
//         <div className="form-group">
//           <label htmlFor="lastname">Last Name</label>
//           <input
//             type="text"
//             className="form-control"
//             id="lastname"
//             name="lastname"
//             value={member.lastname || ""}
//             onChange={handleInputChange}
//             required
//           />
//         </div>
        
//         <div className="form-group">
//           <label htmlFor="email">Email</label>
//           <input
//             type="email"
//             className="form-control"
//             id="email"
//             name="email"
//             value={member.email || ""}
//             onChange={handleInputChange}
//             required
//           />
//         </div>
        
//         <div className="form-group">
//           <label htmlFor="phone">Phone</label>
//           <input
//             type="text"
//             className="form-control"
//             id="phone"
//             name="phone"
//             value={member.phone || ""}
//             onChange={handleInputChange}
//             required
//           />
//         </div>
        
//         <div className="form-group">
//           <label htmlFor="address1">Address 1</label>
//           <input
//             type="text"
//             className="form-control"
//             id="address1"
//             name="address1"
//             value={member.address1 || ""}
//             onChange={handleInputChange}
//             required
//           />
//         </div>
        
//         <div className="form-group">
//           <label htmlFor="address2">Address 2</label>
//           <input
//             type="text"
//             className="form-control"
//             id="address2"
//             name="address2"
//             value={member.address2 || ""}
//             onChange={handleInputChange}
//           />
//         </div>
        
//         <div className="form-group">
//           <label htmlFor="city">City</label>
//           <input
//             type="text"
//             className="form-control"
//             id="city"
//             name="city"
//             value={member.city || ""}
//             onChange={handleInputChange}
//             required
//           />
//         </div>
        
//         <div className="form-group">
//           <label htmlFor="state">State</label>
//           <input
//             type="text"
//             className="form-control"
//             id="state"
//             name="state"
//             value={member.state || ""}
//             onChange={handleInputChange}
//             required
//           />
//         </div>

//         <div className="form-group">
//           <label htmlFor="zip">Zip</label>
//           <input
//             type="text"
//             className="form-control"
//             id="zip"
//             name="zip"
//             value={member.zip || ""}
//             onChange={handleInputChange}
//           />
//         </div>
//       </form>

//       {/* Update status message */}
//       {updateStatus && (
//         <div 
//           className={`alert ${updateStatus.includes('successfully') ? 'alert-success' : 'alert-info'}`}
//           style={{ marginTop: '1rem' }}
//         >
//           {updateStatus}
//         </div>
//       )}

//       {/* Native Camera Capture Modal */}
//       {showNativeCamera && (
//         <NativeCameraCapture
//           mode="photo"
//           multiple={false}
//           maxFiles={1}
//           maxImageSizeMB={10}
//           onCapture={handleNativeCameraCapture}
//           onClose={() => setShowNativeCamera(false)}
//         />
//       )}

//       {/* Image Upload Modal */}
//       {isImageModalOpen && (
//         <ImageUploadModal
//           tenantId={tenant}
//           imageName={`${Date.now()}_${tenant}_${member.firstname}${member.lastname}`}
//           onUploadComplete={handleUploadComplete}
//           onClose={() => setIsImageModalOpen(false)}
//         />
//       )}

//       {/* Footer Buttons */}
//       <AppFooter
//         buttons={[
//           {
//             icon: <FaArrowLeft />,
//             label: 'Cancel',
//             onClick: handleCancel,
//             disabled: uploading
//           },
//           {
//             icon: <FaCamera />,
//             label: 'Photo',
//             onClick: () => setShowNativeCamera(true),
//             disabled: uploading
//           },
//           {
//             icon: <FaUpload />,
//             label: 'Upload',
//             onClick: () => setIsImageModalOpen(true),
//             disabled: uploading
//           },
//           {
//             icon: <FaSave />,
//             label: 'Save',
//             onClick: handleSave,
//             type: 'submit',
//             disabled: uploading
//           },
//         ]}
//       />
//     </div>
//   );
// };

// export default MemberDetail;


import React, { useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { useTranslation } from "react-i18next";
import NativeCameraCapture from '../media/NativeCameraCapture';
import ImageUploadModal from '../media/ImageUploadModal';
import AppFooter from '../AppFooter';
import { FaCamera, FaUpload, FaSave, FaArrowLeft, FaTrash } from 'react-icons/fa';

const MemberDetail = () => {
  const { state } = useLocation();
  const { tenant } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const baseUrl = process.env.REACT_APP_BASE_URL || 'http://localhost:5000';
  
  // Initialize state from passed member data
  const [member, setMember] = useState(state?.member || {});
  const [updateStatus, setUpdateStatus] = useState('');
  const [uploading, setUploading] = useState(false);
  
  // Image/camera state
  const [showNativeCamera, setShowNativeCamera] = useState(false);
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);
  const [imagePath, setImagePath] = useState(member?.image || null);
  const [newImageUrl, setNewImageUrl] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);

  /**
   * Handle native camera capture for updating member photo
   * @param {File[]} capturedFiles - Files captured from native camera
   */
  const handleNativeCameraCapture = async (capturedFiles) => {
    console.log('📸 Captured files for member update:', capturedFiles);
    
    setShowNativeCamera(false);
    
    if (!capturedFiles || capturedFiles.length === 0) {
      return;
    }

    try {
      setUploading(true);
      
      const fileToUpload = capturedFiles[0];
      const formData = new FormData();
      formData.append('file', fileToUpload, fileToUpload.name);

      console.log('📤 Uploading member photo:', fileToUpload.name);

      const uploadResponse = await axios.post(
        `${baseUrl}/api/${tenant}/uploadmember`,
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
          withCredentials: true
        }
      );

      console.log('✅ Upload response:', uploadResponse.data);

      if (uploadResponse.data?.success) {
        const uploadedUrl = 
          uploadResponse.data.url || 
          (uploadResponse.data.filePath ? `${baseUrl}${uploadResponse.data.filePath}` : null);
        
        if (uploadedUrl) {
          setNewImageUrl(uploadedUrl);
          setImagePath(uploadedUrl);
          setSelectedFile(null);
          setMember(prev => ({ ...prev, image: uploadedUrl }));
          console.log('✅ Photo updated successfully:', uploadedUrl);
          setUpdateStatus(t('members.photoUploaded'));
        }
      } else {
        throw new Error(uploadResponse.data?.message || t('members.updateFailed'));
      }
    } catch (error) {
      console.error('❌ Upload failed:', error);
      const errorMessage = 
        error?.response?.data?.message || 
        error?.message || 
        t('members.updateError');
      alert(errorMessage);
      setUpdateStatus(errorMessage);
    } finally {
      setUploading(false);
    }
  };

  /**
   * Handle file upload from ImageUploadModal
   * @param {File[]} files - Files selected from modal
   */
  const handleUploadComplete = async (files) => {
    setIsImageModalOpen(false);
    
    if (!files || files.length === 0) {
      return;
    }

    try {
      setUploading(true);
      
      const fileToUpload = files[0];
      const formData = new FormData();
      formData.append('file', fileToUpload, fileToUpload.name);

      const uploadResponse = await axios.post(
        `${baseUrl}/api/${tenant}/uploadmember`,
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
          withCredentials: true
        }
      );

      if (uploadResponse.data?.success) {
        const uploadedUrl = 
          uploadResponse.data.url || 
          (uploadResponse.data.filePath ? `${baseUrl}${uploadResponse.data.filePath}` : null);
        
        if (uploadedUrl) {
          setNewImageUrl(uploadedUrl);
          setImagePath(uploadedUrl);
          setMember(prev => ({ ...prev, image: uploadedUrl }));
          setUpdateStatus(t('members.photoUploaded'));
        }
      }
    } catch (error) {
      console.error('Upload failed:', error);
      alert(t('members.updateError'));
    } finally {
      setUploading(false);
    }
  };

  /**
   * Remove member photo
   */
  const handleRemovePhoto = () => {
    if (window.confirm(t('members.removePhotoConfirm'))) {
      setImagePath(null);
      setNewImageUrl(null);
      setSelectedFile(null);
      setMember(prev => ({ ...prev, image: null }));
      setUpdateStatus(t('members.photoRemoved'));
    }
  };

  /**
   * Handle input changes for member fields
   */
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setMember((prev) => ({ ...prev, [name]: value }));
    setUpdateStatus('');
  };

  /**
   * Update member information
   */
  const updateMember = async (e) => {
    if (e) e.preventDefault();
    
    setUpdateStatus('');

    try {
      const response = await axios.post(
        `${baseUrl}/api/${tenant}/updatemember`,
        {
          email: member.email,
          firstname: member.firstname,
          lastname: member.lastname,
          address1: member.address1,
          address2: member.address2,
          city: member.city,
          state: member.state,
          zip: member.zip,
          phone: member.phone,
          image: member.image || null,
        },
        { withCredentials: true }
      );

      if (response.data?.success) {
        setUpdateStatus(t('members.updateSuccess'));
        
        setTimeout(() => {
          navigate(`/${tenant}/members`);
        }, 1500);
      } else {
        setUpdateStatus(response.data?.message || t('members.updateFailed'));
      }
    } catch (error) {
      console.error('Error updating member:', error);
      setUpdateStatus(t('members.updateError'));
    }
  };

  const handleCancel = () => {
    navigate(`/${tenant}/members`);
  };

  const handleSave = () => {
    updateMember();
  };

  return (
    <div className="container">
      <h2 className="hdr hdr--primary hdr--lg">{t('members.memberDetails')}</h2>
      
      {/* Upload status indicator */}
      {uploading && (
        <div className="alert alert-info" style={{ marginBottom: '1rem' }}>
          📤 {t('members.uploadingPhoto')}
        </div>
      )}

      {/* Member Photo Preview */}
      {imagePath && (
        <div className="form-group">
          <label>{t('members.memberPhoto')}:</label>
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: 10,
            marginTop: 10
          }}>
            <img
              src={imagePath}
              alt={t('members.memberPhoto')}
              style={{
                width: 150,
                height: 150,
                objectFit: 'cover',
                borderRadius: 8,
                border: '2px solid #ddd'
              }}
              onError={(e) => {
                e.currentTarget.src = '/images/user-icon.png';
              }}
            />
            <button
              type="button"
              className="btn btn-sm btn-danger"
              onClick={handleRemovePhoto}
              disabled={uploading}
              style={{ height: 'fit-content' }}
            >
              <FaTrash /> {t('members.removePhoto')}
            </button>
          </div>
        </div>
      )}

      <form onSubmit={updateMember}>
        <div className="form-group">
          <label htmlFor="firstname">{t('members.firstName')}</label>
          <input
            type="text"
            className="form-control"
            id="firstname"
            name="firstname"
            value={member.firstname || ""}
            onChange={handleInputChange}
            required
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="lastname">{t('members.lastName')}</label>
          <input
            type="text"
            className="form-control"
            id="lastname"
            name="lastname"
            value={member.lastname || ""}
            onChange={handleInputChange}
            required
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="email">{t('members.email')}</label>
          <input
            type="email"
            className="form-control"
            id="email"
            name="email"
            value={member.email || ""}
            onChange={handleInputChange}
            required
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="phone">{t('members.phone')}</label>
          <input
            type="text"
            className="form-control"
            id="phone"
            name="phone"
            value={member.phone || ""}
            onChange={handleInputChange}
            required
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="address1">{t('members.address1')}</label>
          <input
            type="text"
            className="form-control"
            id="address1"
            name="address1"
            value={member.address1 || ""}
            onChange={handleInputChange}
            required
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="address2">{t('members.address2')}</label>
          <input
            type="text"
            className="form-control"
            id="address2"
            name="address2"
            value={member.address2 || ""}
            onChange={handleInputChange}
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="city">{t('members.city')}</label>
          <input
            type="text"
            className="form-control"
            id="city"
            name="city"
            value={member.city || ""}
            onChange={handleInputChange}
            required
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="state">{t('members.state')}</label>
          <input
            type="text"
            className="form-control"
            id="state"
            name="state"
            value={member.state || ""}
            onChange={handleInputChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="zip">{t('members.zip')}</label>
          <input
            type="text"
            className="form-control"
            id="zip"
            name="zip"
            value={member.zip || ""}
            onChange={handleInputChange}
          />
        </div>
      </form>

      {/* Update status message */}
      {updateStatus && (
        <div 
          className={`alert ${updateStatus.includes(t('members.updateSuccess')) ? 'alert-success' : 'alert-info'}`}
          style={{ marginTop: '1rem' }}
        >
          {updateStatus}
        </div>
      )}

      {/* Native Camera Capture Modal */}
      {showNativeCamera && (
        <NativeCameraCapture
          mode="photo"
          multiple={false}
          maxFiles={1}
          maxImageSizeMB={10}
          onCapture={handleNativeCameraCapture}
          onClose={() => setShowNativeCamera(false)}
        />
      )}

      {/* Image Upload Modal */}
      {isImageModalOpen && (
        <ImageUploadModal
          tenantId={tenant}
          imageName={`${Date.now()}_${tenant}_${member.firstname}${member.lastname}`}
          onUploadComplete={handleUploadComplete}
          onClose={() => setIsImageModalOpen(false)}
        />
      )}

      {/* Footer Buttons */}
      <AppFooter
        buttons={[
          {
            icon: <FaArrowLeft />,
            label: t('common.cancel'),
            onClick: handleCancel,
            disabled: uploading
          },
          {
            icon: <FaCamera />,
            label: t('members.photo'),
            onClick: () => setShowNativeCamera(true),
            disabled: uploading
          },
          {
            icon: <FaUpload />,
            label: t('members.upload'),
            onClick: () => setIsImageModalOpen(true),
            disabled: uploading
          },
          {
            icon: <FaSave />,
            label: t('common.save'),
            onClick: handleSave,
            type: 'submit',
            disabled: uploading
          },
        ]}
      />
    </div>
  );
};

export default MemberDetail;